export default {
    methods: {
        getDate(date, format) {
            if (Number.isNaN(date)) return '';

            const months = [
                'stycznia',
                'lutego',
                'marca',
                'kwietnia',
                'maja',
                'czerwca',
                'lipca',
                'sierpnia',
                'września',
                'października',
                'listopada',
                'grudnia'
            ];
            const monthsShort = [
                'sty',
                'lut',
                'mar',
                'kwi',
                'maj',
                'cze',
                'lip',
                'sie',
                'wrze',
                'paź',
                'lis',
                'gru'
            ];

            const givenDate = new Date(date);

            // dziś
            const todayDate = new Date();
            todayDate.setHours(0);
            todayDate.setMinutes(0);
            todayDate.setSeconds(0);

            // wczoraj
            const yesterdayDate = (d => new Date(d.setDate(d.getDate() - 1)))(
                new Date()
            );
            yesterdayDate.setHours(0);
            yesterdayDate.setMinutes(0);
            yesterdayDate.setSeconds(0);

            // jutro
            const tomorrowDate = (d => new Date(d.setDate(d.getDate() + 1)))(
                new Date()
            );
            tomorrowDate.setHours(0);
            tomorrowDate.setMinutes(0);
            tomorrowDate.setSeconds(0);

            // pojutrze
            const afterTomorrowDate = (d =>
                new Date(d.setDate(d.getDate() + 2)))(new Date());
            afterTomorrowDate.setHours(0);
            afterTomorrowDate.setMinutes(0);
            afterTomorrowDate.setSeconds(0);

            const h = `0${givenDate.getHours()}`.slice(-2);
            const m = `0${givenDate.getMinutes()}`.slice(-2);
            const ds = `${givenDate.getDate()}`.slice(-2);
            const d = `0${givenDate.getDate()}`.slice(-2);
            const mo = `0${givenDate.getMonth() + 1}`.slice(-2);
            const ms = months[givenDate.getMonth()];
            const mss = monthsShort[givenDate.getMonth()];
            const y = givenDate.getFullYear();
            let nameDay = '';

            if (givenDate < todayDate && givenDate >= yesterdayDate) {
                nameDay = 'Wczoraj';
            } else if (
                givenDate > tomorrowDate &&
                givenDate < afterTomorrowDate
            ) {
                nameDay = 'Jutro';
            } else if (givenDate > todayDate && givenDate < tomorrowDate) {
                nameDay = 'Dziś';
            }

            const outputDate = format
                .replace('$h', h)
                .replace('$m', m)
                .replace('$ds', ds)
                .replace('$d', d)
                .replace('$nn', mo)
                .replace('$nt', ms)
                .replace('$ns', mss)
                .replace('$y', y)
                .replace('$t', nameDay);

            return outputDate;
        }
    }
};
